//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
export default {
    name: 'index',
    mixins: [SEO,JSONSCHEMA],
    data: () => ({
        page: {},
    }),

    computed: {
        generaleSettings () {
            return this.$store.state.generaleSettings
        },

        center() {
            var x = {
                lat:(this.generaleSettings.find(x => x.slug === 'latitude')&&this.generaleSettings.find(x => x.slug === 'latitude').value)?parseFloat(this.generaleSettings.find(x => x.slug === 'latitude').value):41.06401645451886,
                lng:(this.generaleSettings.find(x => x.slug === 'longitude')&&this.generaleSettings.find(x => x.slug === 'longitude').value)?parseFloat(this.generaleSettings.find(x => x.slug === 'longitude').value):28.806586169206412
            }
            return x
        }
    },

  async asyncData({$api}) {
  try {
    const response = await $api.fetchContactUsPage()
    return { page: response.content }
  } catch (error) {
    console.error(error)
  }
},
};
